<template>
  <div class="layout__container layout__padding-20-0">
    <div class="layout__padding-clear layout__width-800px">
      <StepGuide :stepCount="2" />
    </div>

    <div class="layout__padding-20-0">

      <div class="layout__width-100 colour__background-light-grey layout__position-left layout__padding-20px">
        <div class="layout__padding-clear layout__width-80">
          <h3 class="text__align-center text__colour-teal layout__padding-20px">My Billing Details</h3>
          <div class="component__columns-2">
            <div class="layout__padding-20px">
              <div class="text__colour-teal">Billing Details</div>
              <p class="text__white_space-pre-line text__line-height-2">
                {{ customerDetails.invoiceAddress }}
              </p>
            </div>
          </div>
          <div class="component__columns-2 layout__border__left-1px">
            <div class="layout__padding-0-20">
              <div class="left text__colour-teal d-flex justify-between align-center">
                Delivery Details
                <el-button
                  class="button-teal button__base"
                  @click="isAddressEdit = true"
                >
                  Edit address
                </el-button>
              </div>
              <el-form
                :model="customerDetails"
                ref="customerDetails"
                :rules="addressRules"
                class="layout__padding-20-0"
              >
                <el-form-item
                  class="layout__padding__top-30px"
                  prop="address1"
                >Address Line 1<span
                  class="text__colour-red"
                >*</span>
                  <el-input
                    class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                    placeholder="Address Line 1"
                    v-model="customerDetails.address1"
                    clearable
                    :disabled="!isAddressEdit"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="address2">Address Line 2
                  <el-input
                    class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                    placeholder="Address Line 2"
                    v-model="customerDetails.address2"
                    clearable
                    :disabled="!isAddressEdit"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="address3">Address Line 3
                  <el-input
                    class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                    placeholder="Address Line 3"
                    v-model="customerDetails.address3"
                    clearable
                    :disabled="!isAddressEdit"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="town">Town/City<span class="text__colour-red">*</span>
                  <el-input
                    class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                    placeholder="Town/City"
                    v-model="customerDetails.town"
                    clearable
                    :disabled="!isAddressEdit"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="county">County<span class="text__colour-red">*</span>
                  <el-input
                    class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                    placeholder="County"
                    v-model="customerDetails.county"
                    clearable
                    :disabled="!isAddressEdit"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="postcode">Postcode<span class="text__colour-red">*</span>
                  <el-input
                    class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                    placeholder="Postcode"
                    v-model="customerDetails.postcode"
                    clearable
                    :disabled="!isAddressEdit"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="accountsEmail">Invoice Email<span
                  class="text__colour-red"
                >*</span>
                  <el-input
                    class="layout__width-75 layout-900__width-100 layout__padding-clear layout__position-right"
                    placeholder="Invoice Email"
                    v-model="customerDetails.accountsEmail"
                    clearable
                    :disabled="!isAddressEdit"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>

        </div>
      </div>


      <div class="layout__padding-clear layout__width-80">
        <div class="layout__padding-20px">
          <h3 class="text__align-center text__colour-teal layout__padding__bottom-10px">
            My Order Summary</h3>
          <div
            v-for="printJobItem in printJobsData"
            :key="printJobItem.id"
          >
            <div
              class="layout__height-100 layout__padding-20px layout__position-center"
            >
              <div class="">
                <div class="component__forms-5 text__align-center">
                  <div class="component__subtitle text__colour-teal">Artwork Preview</div>
                  <img
                    class="layout__width-200px layout__padding-20-0"
                    v-bind:src="printJobItem.imageUrlThumb[0].thumbnailURL"
                  >
                </div>

                <div class="component__forms-5">
                  <div class="component__subtitle text__colour-teal">Paper Type</div>
                  <div class="layout__padding-20-0">{{ printJobItem.printJobSpec.stockType }}</div>
                </div>

                <div class="component__forms-5">
                  <div class="text__colour-teal">Paper Weight</div>
                  <div class="layout__padding-20-0">
                    <span v-if="printJobItem.printJobSpec.stockWeight === 'DUR'">DURATRAN</span>
                    <span v-if="printJobItem.printJobSpec.stockWeight === 'INTRAN'">INTRAN</span>
                    <span v-if="printJobItem.printJobSpec.stockWeight === 'TRU'">TRUCARD</span>
                    <span v-if="printJobItem.printJobSpec.stockWeight !== 'INTRAN' && printJobItem.printJobSpec.stockWeight !== 'DUR' && printJobItem.printJobSpec.stockWeight !== 'TRU'">
                      {{ printJobItem.printJobSpec.stockWeight }}
                    </span>
                    <span v-if="printJobItem.printJobSpec.stockWeight !== 'INTRAN' && printJobItem.printJobSpec.stockWeight !== 'DUR' && printJobItem.printJobSpec.stockWeight !== 'TRU' && printJobItem.printJobSpec.stockWeight !== null">
                      gsm
                    </span>
                  </div>
                </div>

                <div class="component__forms-5">
                  <div class="component__subtitle text__colour-teal">Finishing</div>
                  <div
                    class="layout__padding-20-0"
                    v-show="printJobItem.printJobSpec.lamination === 'STANDARD' || printJobItem.printJobSpec.lamination === '' || printJobItem.printJobSpec.lamination === 'NONE' || printJobItem.printJobSpec.lamination === 'SILK'"
                  >
                    No Lamination
                  </div>
                  <div
                    class="layout__padding-20-0"
                    v-show="printJobItem.printJobSpec.lamination === 'MATT LAM'"
                  >
                    Matt Lamination
                  </div>
                  <div
                    class="layout__padding-20-0"
                    v-show="printJobItem.printJobSpec.lamination === 'GLOSS LAM'"
                  >
                    Gloss Lamination
                  </div>
                </div>

                <div class="component__forms-5">
                  <div class="component__subtitle text__colour-teal">Quantity</div>
                  <div class="layout__padding-20-0">{{ printJobItem.printJobSpec.quantity }}</div>
                </div>

                <div
                  v-if="printJobItem.printJobSpec.envelopeAvailable"
                  class="component__forms-5"
                >
                  <div class="component__subtitle text__colour-teal">Envelope</div>
                  <div class="layout__padding-20-0">{{ printJobItem.printJobSpec.envelope ? 'Yes' : 'No' }}</div>
                </div>
              </div>
            </div>

            <div
              class="layout__width-100 layout__border__bottom layout__padding__bottom-20px text__align-right"
            >
              <el-button
                class="button-teal button__base layout__width-150px"
                @click="amendPrintJob(printJobItem)"
              >
                Amend item
              </el-button>
            </div>
          </div>

          <div class="layout__padding__top-20px">
            <el-button
              class="button-red button__base layout__width-150px ml-auto layout__display-block"
              @click="uploadMore"
            >
              Upload more
            </el-button>
          </div>
        </div>
      </div>

      <div class="colour__background-light-grey layout__position-left layout__width-100">
        <div class="layout__padding-clear layout__width-80">
          <div class="layout__padding-20px text__align-right">
            <h3 class="text__align-center text__colour-teal layout__padding__bottom-10px layout__padding-20px">
              My Checkout Summary
            </h3>

            <div
              class="layout__width-100 layout__border__top-1px layout__padding__top-20px"
              v-for="printJobItem in printJobsData"
              :key="printJobItem.id"
            >
              <p class="text__colour-teal layout__padding__bottom-20px">
                Job Reference {{ printJobItem.customerRef }}
              </p>
              <p class="layout__width-100 layout__padding__bottom-10px">
                Sub Total: {{ formatCurrencyTwoPlaces(printJobItem.netTotalPrice + printJobItem.voucherValue) }}
              </p>

              <p
                v-if="printJobItem.voucherUsed"
                class="text__colour-red layout__padding__bottom-10px"
              >
                Voucher discount applied ({{ printJobItem.voucherUsed }}):
                -{{ formatCurrencyTwoPlaces(printJobItem.voucherValue) }}
              </p>

              <div class="component__price-title layout__width-100 text__align-right text__colour-teal layout__margin-2-0 layout__padding__bottom-20px">
                Item total: {{
                  formatCurrencyTwoPlaces(printJobItem.grossTotalPrice ? printJobItem.grossTotalPrice : 0)
                }}
              </div>
            </div>

            <div class="component__price-title layout__width-100 text__align-right text__colour-teal layout__border__top-1px layout__margin-2-0 layout__padding-20px-0 text__size-18">
              <div class="mb-10">
                Delivery charge: {{ calculateDeliveryCharge }}
              </div>
              <div class="mb-10">
                {{ printJobsData && printJobsData.length === 1 ? 'Item' : 'Items' }} total:
                {{ formatCurrencyTwoPlaces(jobsTotalWithoutVAT) }}
              </div>
              <div class="mb-10">
                VAT: {{ orderTotalVAT }}
              </div>
              <div class="mb-10 text__style-bold">
                Order total: {{ instantPrintJobsTotalWithChargePrice }}
              </div>
            </div>

            <div
              v-if="paygInstantPrintExtraCharge && false"
              class="text__align-center text__colour-red"
            >
              * An additional fee will be collected in case of payment by a credit card -
              &pound;{{ paygInstantPrintExtraCharge }} + VAT
            </div>
          </div>

          <el-form
            :model="voucherCode"
          >
            <el-form-item
              prop="voucherUsed"
              class="layout__width-500px layout__padding-clear layout__padding__top-30px"
            >
              <div class="text__size-18 layout__display-inline-block text__colour-teal">Voucher Code</div>
              <el-input
                v-model="voucherCode.voucherUsed"
                clearable
                class="layout__width-300px layout__padding-clear layout__position-right"
                placeholder="Enter a voucher code"
              />
            </el-form-item>
            <div class="layout__width-75 layout__position-center text__colour-teal text__direction-left-to-right">
              <p
                v-show="voucherMessage"
                :class="['component__message-base text__white_space-normal', printJobsData[0].voucherUsed ? 'component__message-success' : 'component__message-fail']"
              >
                {{ voucherMessage }}
              </p>
            </div>

            <div class="layout__width-75 layout__padding-clear text__align-center text__size-12">
              <div class="layout__padding-10px-0">
                Voucher codes cannot be used in conjunction with any other offer.
              </div>
            </div>
            <div class="layout__width-75 layout__padding-clear text__align-center">
              <div class="text__align-center layout__padding-20-0">
                <el-button
                  type="button"
                  class="button-teal button__base layout__width-200px"
                  @click="validateVoucher()"
                >
                  Apply Voucher
                </el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <div class="layout__padding-clear layout__width-80 layout__position__relative">
        <div class="layout__padding-20px">
          <el-form
            :model="{}"
          >
            <el-form-item
              prop="voucherUsed"
              class="layout__width-500px layout__padding-clear layout__padding__top-30px"
            >
              <div class="text__size-18 layout__display-inline-block text__colour-teal">My custom reference</div>
              <el-input
                v-model="customPurchaseOrderId"
                clearable
                class="layout__width-300px layout__padding-clear layout__position-right"
                placeholder="Enter a custom reference"
              ></el-input>
            </el-form-item>
          </el-form>

          <h3 class="text__align-center text__colour-teal layout__padding__bottom-10px layout__padding-20px">
            My Order
          </h3>

          <div class="text__align-center layout__padding-20-0">
            <el-button
              v-if="isAccount"
              class="button-red button__base layout__width-200px layout__margin__right-20px"
              @click="validateAddress(() => activateMessageDialog = true)"
            >
              Continue with account
            </el-button>
            <!--<el-button
              class="button-red button__base layout__width-200px layout__cursor-pointer"
              @click="validateAddress(() => activateCheckout = true)"
            >
              Continue with card
            </el-button>-->
          </div>

          <p class="text__align-center text__size-12 layout__padding-clear">
            Please check the details above carefully
            <br>
            If you need to make changes, please contact Ravensworth Client Support
            <br>
          </p>
          <div class="text__colour-teal text__align-center text__size-12">
            01865 712211
            <br>
            orders@printconcern.co.uk
          </div>
        </div>

        <router-link
          to="/directmailr"
          class="link__colour-teal"
        >
          <el-button class="button__background-tickled-pink button__promo checkout preserve-bg">
            <h3 class="mb-0">
              20/20 campaigns <br><br>
              from just £22.80
            </h3>
          </el-button>
        </router-link>
      </div>
    </div>


    <el-dialog
      :visible.sync="activateMessageDialog"
      width="500px"
      class="rounded"
      @close="singleJob = null"
    >
      <div class="layout__padding-clear text__align-center">

        <div class="text__align-center text__colour-white">
          <div class="layout__padding-clear">
            <h3 class="text__colour-teal">Would you like to proceed with the order?</h3>
          </div>
        </div>

        <div class="layout__padding-20-0">
          <p class="text__size-16 text__white_space-pre-line">By clicking place order you are confirming
            your artwork file is print ready, agree to pay {{ instantPrintJobsTotalWithChargePrice }}
            and comply to Ravensworth payment terms.
          </p>
        </div>

        <div class="">

          <p>Delivery can be expected in 2-3 working days**</p>
          <p>If you have any queries, please contact</p>
          <div class="layout__padding-20-0">
            <p>Ravensworth Client Services:</p>
            <p class="text__colour-teal">01865 712211</p>
            <p class="text__colour-teal">orders@printconcern.co.uk</p>
          </div>

        </div>
        <el-button
          class="button-teal button__base layout__width-150px layout__margin__right-20px"
          @click="activateMessageDialog = false"
        >Cancel
        </el-button>
        <el-button
          class="button-red button__base layout__width-150px"
          @click="next()"
        >
          Confirm Order
        </el-button>

        <div class="text__size-12 layout__padding-20-0">
          <br>
          **Please allow an additional 24 hours for saddle stitched jobs.
          <br>
          Invoices are issued at the beginning of the month. Payment terms are 30 days.
          <br>
          <a
            href="https://ravensworth.co.uk/terms-and-conditions/"
            target="_blank"
            class="link__colour-black"
          >
            Ravensworth Terms and Conditions
          </a>

        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="incompleteInstantPrint"
      width="500px"
    >
      <div class="layout__position-center text__align-center">
        <h3 class="text__colour-teal layout__padding-20-0">Please complete your Instant Print
          <br>
          order before
          proceeding to the checkout
        </h3>
        <div class="layout__padding-clear">
          <div class="layout__padding-20-0 text__align-center">
            <el-button
              class="button-red button__base layout__width-150px"
              @click="amendInstantPrint()"
            >Complete Order
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      id="checkoutDialog"
      :visible.sync="activateCheckout"
      width="350px"
      class="rounded"
      @opened="openCheckout()"
      @closed="onClosed"
    >
      <div
        slot="title"
        class="checkoutTitle"
      >
        <img
          class="checkoutPhotofixrLogo"
          src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/basicIcon.png"
        >
        <div class="checkoutHeaderLine1">PDF Upload Payment</div>
        <br>
        <div class="checkoutHeaderLine2">Complete transaction of
          {{ instantPrintJobsTotalWithChargePrice }}
        </div>
      </div>
      <form
        id="payment-form"
        method="POST"
        action="https://merchant.com/charge-card"
      >
        <div class="custom-label">
          <label for="card-number">Card number</label>
        </div>
        <div class="input-container card-number">
          <div class="icon-container">
            <img
              id="icon-card-number"
              src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/card.svg"
              alt="PAN"
            />
          </div>
          <div class="card-number-frame"></div>
          <div class="icon-container payment-method">
            <img id="logo-payment-method" />
          </div>
          <div class="icon-container">
            <img
              id="icon-card-number-error"
              src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/error.svg"
            />
          </div>
        </div>
        <div class="date-and-code">
          <div>
            <div class="custom-label">
              <label for="expiry-date">Expiry date</label>
            </div>
            <div class="input-container expiry-date">
              <div class="icon-container">
                <img
                  id="icon-expiry-date"
                  src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/exp-date.svg"
                  alt="Expiry date"
                />
              </div>
              <div class="expiry-date-frame"></div>
              <div class="icon-container">
                <img
                  id="icon-expiry-date-error"
                  src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/error.svg"
                />
              </div>
            </div>
          </div>
          <div>
            <div class="custom-label">
              <label for="cvv">Security code</label>
            </div>
            <div class="input-container cvv">
              <div class="icon-container">
                <img
                  id="icon-cvv"
                  src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/cvv.svg"
                  alt="CVV"
                />
              </div>
              <div class="cvv-frame"></div>
              <div class="icon-container">
                <img
                  id="icon-cvv-error"
                  src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/error.svg"
                />
              </div>
            </div>
          </div>
        </div>
        <button
          id="pay-button"
          disabled=""
        >
          Pay with Card {{ instantPrintJobsTotalWithChargePrice }}
        </button>
        <div>
          <span class="error-message error-message__card-number"></span>
          <span class="error-message error-message__expiry-date"></span>
          <span class="error-message error-message__cvv"></span>
        </div>
        <p class="payment-error-message"></p>
        <p class="success-payment-message"></p>
      </form>
    </el-dialog>

    <el-dialog
      :visible.sync="paymentErrorDialog"
      width="500px"
      class="rounded"
      @closed="onErrorDialogClosed"
    >
      <div class="layout__position-center text__align-center">
        <h3 class="text__colour-teal layout__padding-20-0">Error completing transaction</h3>
        <p
          class="text__size-16"
          v-html="paymentErrorMessage"
        />

        <div class="layout__padding-20-0">
          <p>Please contact our Ravensworth Client Services team </p>
          <p>01865 712211</p>
          <p>orders@printconcern.co.uk</p>
        </div>
      </div>

      <div class="layout__padding-20-0 text__align-center">
        <el-button
          class="button-teal button__base layout__width-150px text__align-center"
          type="primary"
          @click="paymentErrorDialog = false"
        >
          Ok
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Axios from 'axios';
import Router from '../../../router';
import StepGuide from '@/components/tools/pdfupload/StepGuide.vue';
import { axios } from '@/mixins/Axios.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import { backing } from '@/mixins/Backing.js';
import { sharedQueries } from '@/mixins/SharedQueries.js';
import { Loading } from 'element-ui';

export default {
  name: 'confirmation',

  VAT: 20,

  components: {
    StepGuide,
  },

  props: {
    searchParams: Object,
    printJob: Object,
  },

  mixins: [axios, dataFormatter, backing, sharedQueries],

  data() {
    return {
      uploadPercentage: '',
      customerDetails: {},
      jobReference: '',
      activateMessageDialog: false,
      voucherApplied: '',
      //voucherUsed: '',
      voucherCode: {
        voucherUsed: '',
      },
      printJobs: [],
      jobItem: {},
      incompleteInstantPrint: false,
      incompleteJob: null,
      singleJob: null,

      customPurchaseOrderId: null,

      // checkout
      activateCheckout: false,
      paymentErrorDialog: false,
      token: '',
      paymentErrorMessage: '',

      paygInstantPrintExtraCharge: 0,
      numberOfCharges: 1,

      isAccount: false,

      voucherMessage: '',

      isAddressEdit: false,
      addressRules: {
        address1: [{
          required: true, message: 'address line 1 is required', trigger: 'blur',
        }],
        town: [{
          required: true, message: 'town required', trigger: 'blur',
        }],
        county: [{
          required: true, message: 'county required', trigger: 'blur',
        }],
        postcode: [{
          required: true, message: 'postcode required', trigger: 'blur',
        }],
        accountsEmail: [{
          required: true, message: 'accounts email required', trigger: 'blur',
        }],
      },
    };
  },

  computed: {
    jobsTotal() {
      return this.printJobsData.reduce((acc, curr) => acc + Number(curr.grossTotalPrice), 0);
    },

    jobsTotalWithoutVAT() {
      return this.printJobsData.reduce((acc, curr) => acc + Number(curr.netTotalPrice), 0);
    },

    jobsVAT() {
      return this.printJobsData.reduce((acc, curr) => acc + Number(curr.vatTotalPrice ? curr.vatTotalPrice : 0), 0);
    },

    calculateDeliveryCharge() {
      return this.returnFormattedCurrency(this.paygInstantPrintExtraCharge * this.numberOfCharges);
    },

    instantPrintJobsTotalPrice() {
      return this.returnFormattedCurrency(this.jobsTotal + (this.paygInstantPrintExtraChargeWithVat * this.numberOfCharges));
    },

    orderTotalVAT() {
      return this.returnFormattedCurrency(this.jobsVAT + this.paygInstantPrintExtraChargeVat);
    },

    paygInstantPrintExtraChargeVat() {
      return ((this.paygInstantPrintExtraCharge * this.numberOfCharges) / 100) * this.$options.VAT;
    },

    paygInstantPrintExtraChargeWithVat() {
      return (this.paygInstantPrintExtraCharge * this.numberOfCharges) + this.paygInstantPrintExtraChargeVat;
    },

    instantPrintJobsTotalWithChargePrice() {
      return this.returnFormattedCurrency(
        this.jobsTotal + (this.paygInstantPrintExtraChargeWithVat),
      );
    },

    printJobsData() {
      return this.printJobs || [];
    },
  },

  created() {
    this.jobItem = this.printJob;

    this.isAccount = JSON.parse(window.sessionStorage.getItem('_customer'))?.accountType === 'ACCOUNT';

    if (typeof this.jobItem === 'undefined') {
      this.jobItem = JSON.parse(window.sessionStorage.getItem('_printJob'));
      console.log(this.printJob);
    }

    this.paygInstantPrintExtraCharge = window.sessionStorage.getItem('_paygInstantPrintExtraCharge')
      ? Number(window.sessionStorage.getItem('_paygInstantPrintExtraCharge'))
      : 0;

    this.printJobs = JSON.parse(window.sessionStorage.getItem('_printJobs'));

    this.jobReference = window.sessionStorage.getItem('_propertyName');
    this.customerDetails = JSON.parse(this.returnCookie('_customer'));
    console.log('sorting price');

    if (this.printJob?.voucherUsed !== null) {
      this.voucherApplied = this.printJob?.voucherUsed;
    }

    this.calculateBasketChargesNumber();
  },

  methods: {
    calculateBasketChargesNumber() {
      // so products with a 200gsm paper stock has a delivery time of 24hours = 1 basket charge.
      // All other products have a 48hr delivery time.
      // So for example if there are products in the basket
      // some with a stock of 200gsm and others such as intran this would equal 2 delivery charges
      // because the delivery times are different.
      // If everything in the basket was 200gsm then there would be 1 charge
      const typesOfPapers = [...new Set(
        this.printJobsData.map(job => job.printJobSpec.stockWeight),
      )];

      if (typesOfPapers.includes('200') && typesOfPapers.length > 1) {
        this.numberOfCharges = 2;
      } else {
        this.numberOfCharges = 1;
      }
    },

    validateAddress(callback) {
      this.$refs.customerDetails.validate((isValid) => {
        if (isValid && typeof callback === 'function') {
          callback();

          return;
        }

        this.$refs.customerDetails.$el.scrollIntoView({
          behavior: 'smooth',
        });
      });
    },

    isAddressChanged() {
      const old = JSON.parse(this.returnCookie('_customer'));
      let isChanged = false;

      Object.keys(this.customerDetails).forEach((key) => {
        if (old[key] !== this.customerDetails[key]) {
          isChanged = true;
        }
      });

      return isChanged;
    },

    async next() {
      const isSingleJob = !!this.singleJob;

      let loadingInstance = Loading.service({
        fullscreen: true,
      });

      const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfupload/orders/finalisebasket/`;

      const data = isSingleJob
        ? {
          Ids: [this.singleJob.id],
          customPurchaseOrderId: this.customPurchaseOrderId || null,
        }
        : {
          Ids: this.printJobsData.map(printJob => printJob.id),
          customPurchaseOrderId: this.customPurchaseOrderId || null,
        };

      if (this.isAddressChanged()) {
        data['customerAddress'] = {
          address1: this.customerDetails.address1,
          address2: this.customerDetails.address2,
          address3: this.customerDetails.address3,
          town: this.customerDetails.town,
          county: this.customerDetails.county,
          postcode: this.customerDetails.postcode,
          accountsEmail: this.customerDetails.accountsEmail,
        };
      }

      this.activateMessageDialog = false;

      console.log('finalised url ', url);
      console.log('finalised printJob', this.printJob);

      Axios.put(url, data, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response);
          const printJobs = typeof (response.data.results) === 'string' ? JSON.parse(response.data.results) : response.data.results;

          if (!printJobs.filter(printJob => !printJob.orderFinalised).length) {
            this.$nextTick(() => { // Loading should be closed asynchronously
              loadingInstance.close();
            });

            Router.push({
              name: '/instant-print/confirmation',
              params: {
                printJobs,
                searchParams: this.searchParams,
              },
            });
          } else {
            const notFinalisedPrintJobs = printJobs.filter(printJob => !printJob.orderFinalised)
              .filter(printJob => printJob.message);

            this.paymentErrorDialog = true;
            this.paymentErrorMessage = `
              Error occured while processing order. See below for more details.<br>
              ${notFinalisedPrintJobs.map(printJob => `${printJob.order.id}: ${printJob.message}`).join('<br>')}
            `;

            this.$nextTick(() => { // Loading should be closed asynchronously
              loadingInstance.close();
            });
          }
        })
        .catch(error => {
          this.paymentErrorDialog = true;
          this.paymentErrorMessage = error.response?.data?.error || 'Something went wrong while processing order';
          this.$nextTick(() => { // Loading should be closed asynchronously
            loadingInstance.close();
          });
        });
    },

    amendPrintJob(printJob) {
      Router.push({
        name: '/instant-print/print-selections',
        params: {
          printJob,
          searchParams: this.searchParams,
          preferences: printJob.printJobSpec,
        },
      });
    },

    uploadMore() {
      Router.push({
        name: '/instant-print',
        params: {
          isCustomStep: true,
        },
      });
    },

    async validateVoucher() {
      const promises = [];

      const bMark = URL.createObjectURL(new Blob()).slice(-36);

      this.printJobsData.forEach((printJobData) => {
        const voucherUrl = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/orders/${printJobData.id}?couponCode=${this.voucherCode.voucherUsed}&basketMark=${bMark}`;

        let putData = {
          'printJobSpec': {
            'quantity': printJobData.printJobSpec.quantity,
          },
        };

        try {
          const response = Axios.put(voucherUrl, putData, this.returnHeaderUsingToken());

          promises.push(response);
        } catch (e) {
          console.log(e);
        }
      });

      const jobs = await Promise.all(promises);

      jobs.forEach((job) => {
        this.handlePrintJobs(job.data);
        this.printJobs = JSON.parse(window.sessionStorage.getItem('_printJobs'));
      });

      this.voucherAction();
    },

    voucherAction() {
      const allJobsHasVoucher = this.printJobsData.filter(printJobData => printJobData.voucherUsed).length === this.printJobsData.length;

      if (allJobsHasVoucher) {
        this.voucherMessage = 'Voucher successfully applied';

        return;
      }

      if (this.printJobsData.filter(printJobData => printJobData.voucherUsed).length === 0) {
        this.voucherMessage = this.printJobsData[0]?.offerNotes || 'Voucher can\'t be applied';

        return;
      }

      this.voucherMessage = 'The voucher code has been successfully applied to some but not all orders';
    },

    isBulkVoucherApplied() {
      //todo always evaluate if a bulk voucher is applied
      if (this.printJob?.voucherUsed === 'PFBULK5PLUS') {
        this.jobItem.voucherUsed = '';
        this.voucherApplied = '10%';
      } else if (this.printJob?.voucherUsed === 'PFBULK10PLUS') {
        this.printJobsData[0].voucherUsed = '';
        this.voucherApplied = '20%';
      }
    },

    reworkedVouchers(oldVoucher) {
      this.voucherApplied = this.printJob?.voucherUsed;
      document.getElementById('voucherNoticeSuccess').style.display = 'none';
      document.getElementById('voucherNoticeFail').style.display = 'none';

      /**
       * the parameter will be the voucher submitted into the request - this might on be the voucher applied to the job once it's been returned
       *
       * two things going on here - one get the right message on screen underneath the apply voucher button and then pretty print the voucher value and type
       * messaging will be done like so: message inner text, message style, display block
       *
       */


      /**
       * the voucher has been successfully applied
       */
      if (oldVoucher === this.printJob?.voucherUsed) {
        this.isBulkVoucherApplied();
        document.getElementById('voucherNoticeSuccess').innerText = 'Voucher Applied Successfully';
        document.getElementById('voucherNoticeSuccess').classList.add('component__message-base', 'component__message-success');
        document.getElementById('voucherNoticeSuccess').style.display = 'block';
      } else if (this.printJobsData[0].offerNotes === 'AppliedVoucherBeatsRequestedVoucher') {
        /**
         * if the voucher remains a bulk voucher sort the front-end out
         */
        this.isBulkVoucherApplied();
        this.printJobs[0].voucherUsed = '';
        document.getElementById('voucherNoticeFail').innerText = 'Sorry, ' + oldVoucher + ' voucher value is less than the discount already applied. \n Voucher has not been applied';
        document.getElementById('voucherNoticeFail').classList.add('component__message-base', 'component__message-fail');
        document.getElementById('voucherNoticeFail').style.display = 'block';

      } else if (this.printJobsData[0].offerNotes === 'Invalid Voucher') {
        this.printJobs[0].voucherUsed = '';
        this.isBulkVoucherApplied();
        document.getElementById('voucherNoticeFail').innerText = 'Sorry, ' + oldVoucher + ' may not exist or you may not have spent the minimum required value. \n Please review your order or try another voucher';
        document.getElementById('voucherNoticeFail').classList.add('component__message-base', 'component__message-fail');
        document.getElementById('voucherNoticeFail').style.display = 'block';

      } else if (this.printJobsData[0].offerNotes === 'Invalid Voucher - usage count exceeded') {
        this.printJobs[0].voucherUsed = '';
        this.isBulkVoucherApplied();
        document.getElementById('voucherNoticeFail').innerText = 'Sorry, ' + oldVoucher + ' has exceeded usage limits. \n Please try another voucher';
        document.getElementById('voucherNoticeFail').classList.add('component__message-base', 'component__message-fail');
        document.getElementById('voucherNoticeFail').style.display = 'block';

        // } else if (this.printJob?.voucherUsed === null && this.jobItem.offerNotes !== null) {
        //     document.getElementById("voucherNoticeSuccess").style.display = 'none';
        //     document.getElementById("voucherNoticeFail").style.display = 'none';
        //     this.isBulkVoucherApplied()

      } else {
        this.isBulkVoucherApplied();
        document.getElementById('voucherNoticeSuccess').style.display = 'none';
        document.getElementById('voucherNoticeFail').style.display = 'none';
      }
    },

    confirmItem(printJob) {
      if (printJob.printJobSpec.stockWeight === null || printJob.printJobSpec.stockType === null || printJob.printJobSpec.lamination === null || printJob.printJobSpec.quantity === 0) {
        this.incompleteJob = printJob;
        this.incompleteInstantPrint = true;
      } else {
        this.singleJob = printJob;
        this.activateMessageDialog = true;
      }
    },

    confirmOrder() {
      this.incompleteJob = this.printJobsData.find(printJob => {
        return printJob.printJobSpec.stockWeight === null || printJob.printJobSpec.stockType === null || printJob.printJobSpec.lamination === null || printJob.printJobSpec.quantity === 0;
      });

      if (this.incompleteJob) {
        this.incompleteInstantPrint = true;
      } else {
        this.activateMessageDialog = true;
      }
    },

    amendInstantPrint() {
      this.incompleteInstantPrint = false;
      if (this.incompleteJob.printJobSpec.fCode !== null) {
        Router.push({
          name: '/instant-print/print-selections',
          params: {
            printJob: this.incompleteJob,
            searchParams: this.searchParams,
            preferences: this.incompleteJob.printJobSpec,
          },
        });
      } else {
        Router.push({
          name: '/instant-print/artwork-preview',
          params: {
            printJob: this.incompleteJob,
            searchParams: this.searchParams,
          },
        });
      }
    },

    openCheckout() {
      console.log('openCheckout');

      if (document.getElementById('checkoutScript')) {
        const element = document.getElementById('checkoutScript');

        element.parentNode.removeChild(element);
      }

      if (!document.getElementById('checkoutScript')) {
        const checkoutScript = document.createElement('script');

        checkoutScript.onload = async () => {
          const payButton = document.getElementById('pay-button');
          const form = document.getElementById('payment-form');
          let amount;

          const publicKey = {
            publicKey: `${process.env.VUE_APP_CHECKOUTKEY}`,
          };

          Frames.init(publicKey);

          const logos = {
            'card-number': {
              src: 'card',
              alt: 'card number logo',
            },
            'expiry-date': {
              src: 'exp-date',
              alt: 'expiry date logo',
            },
            'cvv': {
              src: 'cvv',
              alt: 'cvv logo',
            },
          };

          const errors = {
            'card-number': 'Please enter a valid card number',
            'expiry-date': 'Please enter a valid expiry date',
            'cvv': 'Please enter a valid cvv code',
          };

          const onValidationChanged = (event) => {
            var e = event.element;

            if (event.isValid || event.isEmpty) {
              if (e === 'card-number' && !event.isEmpty) {
                showPaymentMethodIcon();
              }
              setDefaultIcon(e);
              clearErrorIcon(e);
              clearErrorMessage(e);
            } else {
              if (e === 'card-number') {
                clearPaymentMethodIcon();
              }
              setDefaultErrorIcon(e);
              setErrorIcon(e);
              setErrorMessage(e);
            }
          };

          Frames.addEventHandler(
            Frames.Events.FRAME_VALIDATION_CHANGED,
            onValidationChanged,
          );

          const clearErrorMessage = (el) => {
            const message = document.querySelector(`.error-message__${el}`);

            message.textContent = '';
          };

          const clearErrorIcon = (el) => {
            const logo = document.getElementById(`icon-${el}-error`);

            logo.style.removeProperty('display');
          };

          const showPaymentMethodIcon = (parent, pm) => {
            if (parent) {
              parent.classList.add('show');
            }

            const logo = document.getElementById('logo-payment-method');

            if (pm) {
              const name = pm.toLowerCase();

              logo.setAttribute('src', `https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/${name}.svg`);
              logo.setAttribute('alt', pm || 'payment method');
            }

            logo.style.removeProperty('display');
          };

          const clearPaymentMethodIcon = (parent) => {
            if (parent) {
              parent.classList.remove('show');
            }

            const logo = document.getElementById('logo-payment-method');

            logo.style.setProperty('display', 'none');
          };

          const setErrorMessage = (el) => {
            const message = document.querySelector(`.error-message__${el}`);

            message.textContent = errors[el];
          };

          const setDefaultIcon = (el) => {
            const logo = document.getElementById(`icon-${el}`);

            logo.setAttribute('src', `https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/${logos[el].src}.svg`);
            logo.setAttribute('alt', logos[el].alt);
          };

          const setDefaultErrorIcon = (el) => {
            const logo = document.getElementById(`icon-${el}`);

            logo.setAttribute('src', `https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/card-icons/${logos[el].src}-error.svg`);
            logo.setAttribute('alt', logos[el].alt);
          };

          const setErrorIcon = (el) => {
            const logo = document.getElementById(`icon-${el}-error`);

            logo.style.setProperty('display', 'block');
          };

          const cardValidationChanged = () => {
            payButton.disabled = amount === 0.00
              ? true
              : !Frames.isCardValid();
          };

          const onCardTokenizationFailed = (error) => {
            console.log('CARD_TOKENIZATION_FAILED: %o', error);
            Frames.enableSubmitForm();
          };

          Frames.addEventHandler(
            Frames.Events.CARD_VALIDATION_CHANGED,
            cardValidationChanged,
          );

          Frames.addEventHandler(
            Frames.Events.CARD_TOKENIZATION_FAILED,
            onCardTokenizationFailed,
          );

          const onCardTokenized = (event) => {
            if (event.token !== this.token) {
              this.token = event.token;

              const isSingleJob = !!this.singleJob;

              const data = isSingleJob
                ? {
                  Ids: [this.singleJob.id],
                  customPurchaseOrderId: this.customPurchaseOrderId || null,
                }
                : {
                  Ids: this.printJobsData.map(printJob => printJob.id),
                  customPurchaseOrderId: this.customPurchaseOrderId || null,
                };

              if (this.isAddressChanged()) {
                data['customerAddress'] = {
                  address1: this.customerDetails.address1,
                  address2: this.customerDetails.address2,
                  address3: this.customerDetails.address3,
                  town: this.customerDetails.town,
                  county: this.customerDetails.county,
                  postcode: this.customerDetails.postcode,
                  accountsEmail: this.customerDetails.accountsEmail,
                };
              }

              const finaliseOnlineUrl = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/pdfupload/orders/finalisebasket?paymentValidationToken=${event.token}&random=${Math.random()}`;

              const loadingInstance = Loading.service({
                fullscreen: true,
              });

              Axios.put(finaliseOnlineUrl, data, this.returnHeaderUsingToken())
                .then(response => {
                  this.onClosed();

                  const printJobs = (typeof response.data.results === 'string') ? JSON.parse(response.data.results) : response.data.results;
                  console.log('Payment response:', printJobs);

                  this.$nextTick(() => { // Loading should be closed asynchronously
                    loadingInstance.close();
                  });

                  this.token = '';
                  if (Array.isArray(printJobs) &&
                    printJobs.filter(printJob => printJob.completedOrder?.orderItem?.orderFinalised).length === printJobs.length) {
                    this.$nextTick(() => { // Loading should be closed asynchronously
                      loadingInstance.close();
                    });
                    Router.push({
                      name: '/instant-print/confirmation',
                      params: {
                        printJobs,
                        searchParams: this.searchParams,
                      },
                    });
                  } else {
                    throw response;
                    // alert('failed to take payment')
                    // this.activateMessageDialog = false;
                    // this.paymentErrorDialog = true;
                    // this.paymentErrorMessage = '';
                    // this.activateCheckout = false;
                  }

                })
                .catch(error => {
                  this.onClosed();

                  const ERROR_REPLACE_TEXT = 'Error processing  payment : ';
                  let errorDetails;
                  let message;
                  const errorMessage = error?.data?.message || error?.response?.data?.message || null;

                  if (errorMessage?.includes(ERROR_REPLACE_TEXT)) {
                    message = errorMessage.replace(ERROR_REPLACE_TEXT, '');

                    try {
                      message = JSON.parse(message);
                      let errorM = message.result.errorMessage;
                      const startIdx = errorM.indexOf('{');
                      const endIdx = errorM.lastIndexOf('}');
                      if (startIdx >= 0 && endIdx >= 0) {
                          errorDetails = JSON.parse(errorM.slice(startIdx, endIdx + 1));
                          message = `Payment status: ${errorDetails.Payment.Status}. Reason: ${errorDetails.Payment.ResponseSummary}`;
                      } else {
                          message = errorM;
                      }
                    } catch {
                      message = '';
                    }
                  }

                  this.activateMessageDialog = false;
                  this.paymentErrorDialog = true;
                  this.paymentErrorMessage = message || error?.response?.data?.error || 'Something went wrong while processing order';
                  this.activateCheckout = false;

                  this.$nextTick(() => {
                    // Loading should be closed asynchronously
                    loadingInstance.close();
                  });

                  this.token = '';
                });
            }
          };

          Frames.addEventHandler(
            Frames.Events.CARD_TOKENIZED,
            onCardTokenized,
          );

          const paymentMethodChanged = (event) => {
            const pm = event.paymentMethod;
            const container = document.querySelector('.icon-container.payment-method');

            if (!pm) {
              clearPaymentMethodIcon(container);
            } else {
              clearErrorIcon('card-number');
              showPaymentMethodIcon(container, pm);
            }
          };

          Frames.addEventHandler(
            Frames.Events.PAYMENT_METHOD_CHANGED,
            paymentMethodChanged,
          );

          const onSubmit = (event) => {
            event.preventDefault();
            Frames.submitCard();
          };

          form.addEventListener(
            'submit',
            onSubmit,
          );
        };

        checkoutScript.setAttribute('src', 'https://cdn.checkout.com/js/framesv2.min.js');
        checkoutScript.async = true;
        checkoutScript.id = 'checkoutScript';

        document.head.appendChild(checkoutScript);
      }
    },

    onClosed() {
      Frames.removeAllEventHandlers(Frames.Events.PAYMENT_METHOD_CHANGED);
      Frames.removeAllEventHandlers(Frames.Events.CARD_TOKENIZED);
      Frames.removeAllEventHandlers(Frames.Events.CARD_TOKENIZATION_FAILED);
      Frames.removeAllEventHandlers(Frames.Events.CARD_VALIDATION_CHANGED);
      Frames.removeAllEventHandlers(Frames.Events.FRAME_VALIDATION_CHANGED);
    },

    onErrorDialogClosed() {
      this.paymentErrorMessage = '';
    },
  },
};
</script>